module.exports = __webpack_public_path__ + "img/mobile-rental-title.d655d3f1.svg";